import {
  GET_OT_PAYMENT_TRANSACTIONS,
  GET_OT_PAYMENT_TRANSACTIONS_SUCCESS,
  GET_OT_PAYMENT_TRANSACTIONS_FAILURE,
} from '../actions/otPaymentTransactions';

const INITIAL_STATE = { loading: true };

export default function otPaymentTransactionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_OT_PAYMENT_TRANSACTIONS:
      return {
        ...state,
        loading: true,
      };
    case GET_OT_PAYMENT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        otPaymentTransactions: action.payload,
      };
    case GET_OT_PAYMENT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
